import React from 'react';
import { useAtom } from 'jotai';

import { meAtom } from '@/store/me.store';
import { hasEveryFlag } from '@/utils/common/feature-flag';

interface Props {
  children: React.ReactElement;
  requiredFlags: string[];
}

const FeatureFlag = ({ children, requiredFlags }: Props): React.ReactElement | null => {
  const [me] = useAtom(meAtom);
  // eslint-disable-next-line unicorn/no-null
  return me && hasEveryFlag(me, requiredFlags) ? children : null;
};

export default FeatureFlag;
